<template>
  <ul class="Wdgt-Search-Market-Stub">
    <li class="Wdgt-Search-Market-Stub__item">
      <SkeletAvatar />
      <SkeletItem style="width: 80px" :height="24" />
      <SkeletItem style="width: 50px" :height="24" />
      <SkeletItem style="width: 48px" :height="24" />
    </li>
  </ul>
</template>

<script setup>
  import SkeletAvatar from '@ui/Skeletons/SkeletAvatar/SkeletAvatar.vue';
  import SkeletItem from '@ui/Skeletons/SkeletItem/SkeletItem.vue';
</script>

<style lang="scss">
  @import './styles/_styles.scss';
</style>